import { computed, ref } from 'vue'

export const useMenuPosition = () => {
  const triggerRect = ref<DOMRect | null>(null)

  function openMenu(event: MouseEvent) {
    triggerRect.value = (
      event.currentTarget as HTMLElement
    ).getBoundingClientRect()
  }

  function closeMenu() {
    triggerRect.value = null
  }

  const vw = () => window.innerWidth
  const vh = () => window.innerHeight

  const isOnRightSide = computed(() => (triggerRect.value?.x ?? 0) / vw() > 0.5)
  const isOnBottom = computed(() => (triggerRect.value?.y ?? 0) / vh() > 0.5)

  const computedStyles = computed(() => {
    const r = triggerRect.value
    if (!r) return {}

    const offset = 8

    return {
      top: isOnBottom.value ? '' : `${r.bottom + offset}px`,
      bottom: isOnBottom.value ? `${vh() - r.top + offset}px` : '',
      left: isOnRightSide.value ? '' : `${r.left}px`,
      right: isOnRightSide.value ? `${vw() - r.right}px` : '',
    } as Record<string, string>
  })

  return { triggerRect, openMenu, closeMenu, computedStyles }
}
